'use client';

import Link from 'next/link';
import { MARKETPLACE_SELLER_TERMS_VERSION } from '@/platform/legal/marketplacePolicy';

export type MarketplaceSellerTermsAcceptanceProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
};

export function MarketplaceSellerTermsAcceptance({
  checked,
  onChange,
  disabled,
  id = 'marketplace-seller-terms',
}: MarketplaceSellerTermsAcceptanceProps) {
  return (
    <div className="marketplace-seller-terms-acceptance">
      <p className="text-muted">
        Seller terms version {MARKETPLACE_SELLER_TERMS_VERSION}.{' '}
        <Link href="/legal/marketplace/#seller-terms">Read marketplace seller terms</Link>
      </p>
      <label htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />{' '}
        I agree to the marketplace seller terms and am solely responsible for fulfillment, returns, and refunds.
      </label>
    </div>
  );
}
